<template>
  <section class="bg-loading">
    <div class="columns is-desktop now-loading">
      <div class="column is-offset-10">
        <img class="now-loading-img" src="../../assets/Loading/nowloading.png"/>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "BgLoading"
  }
</script>

<style scoped>
  .columns {
    padding: 0;
    margin: 0;
  }

  .bg-loading {
    background: url('../../assets/Loading/bg-loading.png') repeat;
    width: 100vw;
    height: 100vh;
  }

  .now-loading {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .now-loading-img {
    position: absolute;
    bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading/BgLoading.vue